import {FormEvent, useState} from 'react';
import Select from 'react-select';
import { IDigitalWalletScreeningSearchParams } from 'src/types';

const blocknains = [
  { label: 'Bitcoin', value: 0 },
  { label: 'Ethereum', value: 1 },
  { label: 'Litecoin', value: 2 },
  { label: 'Bitcoin Cash', value: 3 },
  { label: 'Ripple', value: 4 },
  { label: 'Bitcoin SV', value: 5 },
  { label: 'Dogecoin', value: 6 },
  { label: 'Zillliqa', value: 7 },
  { label: 'Binance Coin', value: 8 },
  { label: 'Matic', value: 9 },
  { label: 'Tron', value: 10 },
  { label: 'Cardano', value: 11 },
  { label: 'Polkadot', value: 12 },
  { label: 'Stellar', value: 13 },
];

interface OptionType {
    label: string;
    value: number;
}

interface Props {
    screen: (params: IDigitalWalletScreeningSearchParams) => void
    screeningComplete: boolean
}

const DigitalWalletSearchForm: (props: Props) => JSX.Element = (props: Props) => {
    const defaultSearchParams: IDigitalWalletScreeningSearchParams = {
        identifier: '',
        currency: null,
    };
    const [searchParameters, setSearchParameters] = useState<IDigitalWalletScreeningSearchParams>({...defaultSearchParams});
    const [blockchainSelectValue, setBlockchainSelectValue] = useState<OptionType | null>(null);

    const options: any = [...blocknains];

    /**
     * This function performs the basic validation before screening
     * @param e
     */
    const screen = (e: FormEvent) => {
        e.preventDefault();
        let valid = true;
        if (!searchParameters.identifier || searchParameters.currency === null)
            valid = false;
        valid && props.screen({...searchParameters})
    }

    const clear = () => {
        setSearchParameters({...defaultSearchParams});
        setBlockchainSelectValue(null);
    }

    return (
      <div className="col-lg-12 card top-head p-0 overflow-visible">
          <div className="py-4 px-4">
              <form onSubmit={screen}>
                  <div className="d-flex gap-3 align-items-end flex-wrap">
                      <div className='w-50'>
                          <label className="form-label">Address*</label>
                          <input
                              name='first_name'
                              className='form-control'
                              type="text"
                              placeholder='Enter wallet address'
                              required
                              value={searchParameters.identifier}
                              onChange={
                                  (e) => {
                                      setSearchParameters({...searchParameters, identifier: e.target.value})
                                  }
                              }
                          />
                      </div>
                      <div className='flex-grow-1'>
                        <label className="form-label">Blockchain*</label>
                        <Select
                            className="dynamic-countries"
                            name='blockchain'
                            options={options}
                            value={blockchainSelectValue}
                            onChange={newValue => {
                                const selected = newValue as unknown as OptionType;
                                setBlockchainSelectValue(selected);
                                setSearchParameters({
                                    ...searchParameters,
                                    currency: selected.value
                                })
                            }}
                        />
                      </div>
                      <div className='button-group text-right custom-actions flex-shrink-0'>
                          <button
                              type='button'
                              className='button btn-grey-border'
                              onClick={clear}
                          >
                              Clear
                          </button>
                          <button
                              type='submit'
                              className='button btn-with-icon grey-btn'
                          >
                              <img
                                  src={require('src/assets/images/icons/screen-icon.svg').default}
                                  alt=""
                              />
                              Screen
                          </button>
                      </div>
                  </div>
              </form>
          </div>
      </div>
    );
};

export default DigitalWalletSearchForm;
